import {useState} from "react";
import {AccountSearch} from "./search/AccountSearch"
import {AccountTable} from "./table/AccountTable"
import {searchInit} from "./init/searchInit";
import {CreateAccountInterface} from "../create/interface/CreateAccountInterface";

export const AccountList = () => {

    const [searchData, setSearchData] = useState<CreateAccountInterface[]>([]);
    const [dataCount, setDataCount] = useState(0);
    const [searchParam, setSearchParam] = useState(searchInit)
    const [refresh, setRefresh] = useState(false)

    return (
        <>
            <AccountSearch
                setSearchData={setSearchData}
                setDataCount={setDataCount}
                searchParam={searchParam}
                setSearchParam={setSearchParam}
                refresh={refresh}
                setRefresh={setRefresh}
            />
            <AccountTable
                searchData={searchData}
                dataCount={dataCount}
                searchParam={searchParam}
                setSearchParam={setSearchParam}
                setRefresh={setRefresh}
            />
        </>
    )
}